var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicBandThumbnailContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "thumbnail-background",
    x: 0.5,
    y: 0.5,
    width: 101,
    height: 101,
    rx: 10.5,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stripe",
    d: "M69.7114 63.2727C55.0107 70.1139 35.9396 91.9455 32.4631 101H27C28.1588 95.6343 33.0591 85.1042 37.4295 77.8606C42.8926 68.8061 52.6755 57.673 66.7315 48.1818C78.651 40.1333 96.1991 23.0303 101 18V46.1697C93.2192 52.2061 84.4121 56.4315 69.7114 63.2727Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stripe",
    d: "M36.4225 101H31C34.9437 91.9174 53.6761 72.2385 61.0704 66.6881C66.6968 62.4648 90.1549 49.8685 101 46V77.789C93.1127 72.2385 73.8873 74.7615 66.493 78.2936C57.8864 82.4047 41.6808 94.6086 36.4225 101Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stripe",
    d: "M64.7325 51.5C42.8231 65.0144 30.4522 92 26.9745 101H23C24.1592 95.6667 33.0357 76.2 37.4076 69C42.8726 60 51.6653 43.934 65.7261 34.5C77.6497 26.5 96.1975 15 101 10V27.5C93.2166 33.5 80.1338 42 64.7325 51.5Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stripe",
    d: "M81 1C35.1727 46.5 24.9319 79 18.0494 101H14.0207C13.2149 73.8 36.1789 23 47.7616 1H81Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-stripe",
    d: "M80.9506 1C35.1233 46.5 24.8825 79 18 101H22.9506C24.1098 95.6667 32.9862 76.2 37.3582 69C37.8428 68.202 38.3535 67.3485 38.8917 66.4489L38.8935 66.446L38.8942 66.4447C44.4264 57.1989 52.8645 43.0962 65.6767 34.5C68.6616 32.4973 72.0616 30.2753 75.5572 27.9908L75.5572 27.9908C85.9828 21.1773 97.2585 13.8083 100.906 10.0458C100.426 4.97052 96.1523 1 90.9513 1H80.9506Z",
    fill: "white",
    stroke: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-note",
    d: "M39.9577 46V52.6667C39.9335 52.6903 39.9289 52.7161 39.9577 52.7393V68.5472C38.6661 67.7771 37.1485 67.3333 35.5248 67.3333C30.8167 67.3333 27 71.0643 27 75.6667C27 80.269 30.8167 84 35.5248 84C40.1188 84 43.864 80.4478 44.043 76H44.0497V53.2918C44.3907 53.8334 45.0727 54.6667 47.8005 55.6667C52.0242 57.215 54.8855 55.7667 55.89 54.7654C56.0017 54.7367 56.0182 54.6997 55.9844 54.6667C55.955 54.699 55.9235 54.7319 55.89 54.7654C55.6262 54.833 54.8317 54.854 52.9154 54.6667C50.3714 54.418 48.9662 52.3139 47.7085 50.4308C47.2805 49.7899 46.8695 49.1745 46.4365 48.6667C45.0726 47.0667 41.549 46.2222 39.9577 46Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-note",
    d: "M62.5109 39V45.6667C62.4875 45.6903 62.483 45.7161 62.5109 45.7393V61.5472C61.2638 60.7771 59.7985 60.3333 58.2309 60.3333C53.6851 60.3333 50 64.0643 50 68.6667C50 73.269 53.6851 77 58.2309 77C62.6664 77 66.2825 73.4478 66.4553 69H66.4617V46.2918C66.791 46.8334 67.4495 47.6667 70.0833 48.6667C74.1613 50.215 76.9239 48.7667 77.8938 47.7654C78.0016 47.7367 78.0175 47.6997 77.9849 47.6667C77.9565 47.699 77.9261 47.7319 77.8938 47.7654C77.6391 47.833 76.872 47.854 75.0218 47.6667C72.5655 47.418 71.2087 45.3139 69.9944 43.4308C69.5811 42.7899 69.1843 42.1745 68.7663 41.6667C67.4494 40.0667 64.0473 39.2222 62.5109 39Z",
    fill: "#1E1E1E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "thumbnail-note",
    d: "M30.5109 23V29.6667C30.4875 29.6903 30.483 29.7161 30.5109 29.7393V45.5472C29.2638 44.7771 27.7985 44.3333 26.2309 44.3333C21.6851 44.3333 18 48.0643 18 52.6667C18 57.269 21.6851 61 26.2309 61C30.6664 61 34.2825 57.4478 34.4553 53H34.4617V30.2918C34.791 30.8334 35.4495 31.6667 38.0833 32.6667C42.1613 34.215 44.9239 32.7667 45.8938 31.7654C46.0016 31.7367 46.0175 31.6997 45.9849 31.6667C45.9565 31.699 45.9261 31.7319 45.8938 31.7654C45.6391 31.833 44.872 31.854 43.0218 31.6667C40.5655 31.418 39.2087 29.3139 37.9944 27.4308C37.5811 26.7899 37.1843 26.1745 36.7663 25.6667C35.4494 24.0667 32.0473 23.2222 30.5109 23Z",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicBandThumbnailContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MusicBandThumbnailContrast.396aa5159a8e57d2c989b4486e7a6ad5.svg";